const body = document.body;
const headerBtn = document.querySelector('.js-header__button');
const onclickPopup = document.querySelector('.js-onclickpopup');
const onclickPopupClose = document.querySelector('.js-onclickpopup__close');

// =======================================================
// Header Button - On Click Popup
// =======================================================
if (headerBtn && onclickPopup && onclickPopupClose) {
    // Open popup
    headerBtn.addEventListener('click', function () {

        if (!onclickPopup.classList.contains('js-open-onclickpopup')) {
            onclickPopup.classList.add('js-open-onclickpopup');
            body.classList.add('js-no-scroll');
        }
        else {
            onclickPopup.classList.remove('js-open-onclickpopup');
            body.classList.remove('js-no-scroll');
        }
    });

    // Close popup
    onclickPopupClose.addEventListener('click', function () {
        if (onclickPopup.classList.contains('js-open-onclickpopup')) {
            onclickPopup.classList.remove('js-open-onclickpopup');
            body.classList.remove('js-no-scroll');
        }
    });

    if (window.innerWidth > 960) {
        document.addEventListener("mouseup", function (event) {
            if (!onclickPopup.contains(event.target) && !headerBtn.contains(event.target)) {
                onclickPopup.classList.remove('js-open-onclickpopup');
                body.classList.remove('js-no-scroll');
            }
        })
    }
}